export const noOfFounders = [
    { "key": "1" },
    { "key": "2" },
    { "key": "3" },
    { "key": "4" },
    { "key": "5" },
    { "key": "6" },
    { "key": "7" },
    { "key": "More than 7" },
];